import React, { useState } from 'react';
import CircularProgressbar from "../common/CircularProgressbar";


function Accordion(props) {
    const { group, index, hideNavLink, onClickHandler, isOverallScore, report } = props;
    const [showContent, setShowContent] = useState(false);
    if (showContent && !hideNavLink) {
        setShowContent(false)
    }
    function onMenuClick() {
        setShowContent(true)
        onClickHandler(group && group.groupTitle || 'Overall score');
    }
    return (
        <div>
            {!hideNavLink && isOverallScore && <div className="accordion-menu-section" onClick={() => { onMenuClick() }}>
                <div className="accordion-menu-score">
                    <CircularProgressbar percentage={report.overallScore} overallScoreColor={"#008fbe"} rotation={0.00} />
                </div>
                <div className="accordion-menu-name">Overall score</div>
                <div className="back-arrow"><span className="icon-arrow-rt"></span></div>
            </div>}
            {!hideNavLink && !isOverallScore && <div className="accordion-menu-section" onClick={() => { onMenuClick() }}>
                <div className="accordion-menu-score">
                    <CircularProgressbar percentage={group.groupScore} overallScoreColor={"#008fbe"} rotation={0.00} />
                </div>
                <div className="accordion-menu-name">{group.groupTitle}</div>
                <div className="back-arrow"><span className="icon-arrow-rt"></span></div>
            </div>}
            {showContent && !isOverallScore && <div key={index} id={group.groupTitle.trimEnd().replace(' ', '_')} className={`answer-group accordion-answer-group`}>
                <div className="category-heading">
                    <CircularProgressbar percentage={group.groupScore} overallScoreColor={"#008fbe"} rotation={0.00} />
                    <div className="page-heading">{group.groupTitle}</div>
                    
                </div>

                <div className="category-body">
                    <div className="row">
                        <div className="col-12">
                            <div>
                                {group.wellnessQuestions.map(question => {
                                    return <div key={question.questionId} className="each-question">
                                        <h3 id={question.questionId} ><strong dangerouslySetInnerHTML={{
                                            __html: question.questionTitle
                                        }} ></strong></h3>
                                        <ul>
                                            {question.answers.map(answer => {
                                                return <li key={answer.optionId} dangerouslySetInnerHTML={{
                                                    __html: answer.optionText
                                                }}></li>
                                            })
                                            }
                                        </ul>
                                    </div>
                                }
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
            {isOverallScore && showContent && <div className="accordion-answer-group">
                <div className="category-heading">
                    <CircularProgressbar percentage={report.overallScore} overallScoreColor={"#008fbe"} rotation={0.00} />
                    <div className="page-heading">{report.overallScoreTitle}</div>
                    
                </div>

                <div className="category-body">
                    <div className="row">
                        <div className="col-12">
                            <div>
                                <p>{report.overallScoreInterpretation}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </div>)
        
}

export default Accordion;